export const GET_SCHEMAS = "get_schemas";
export const GET_SCHEMA_BY_ID = "get_schema_by_id";
export const GET_ASSETS_SCHEMAS = "get_assets_schemas";
export const GET_ALL_PROJECTS = "GET_ALL_PROJECTS";
export const GET_DEALROOMS = "GET_DEALROOMS";
export const GET_DEALROOM_PROJECTS = "GET_DEALROOM_PROJECTS";
export const GET_DEALROOM_FIN_STR = "GET_DEALROOM_FIN_STR";
export const EDIT_DEALROOM_PROJECT = "EDIT_DEALROOM_PROJECT";
export const SIGN_UP_USER = "sign_up_user";
export const EDIT_DEALROOM_FIN_STR = "EDIT_DEALROOM_FIN_STR";
export const EDIT_DEALROOM = "EDIT_DEALROOM";
export const SET_SCENARIO_PROJECTS = "SET_SCENARIO_PROJECTS";
export const GET_DEALROOM_FIN_STR_SCENARIOS = "GET_DEALROOM_FIN_STR_SCENARIOS";
export const GET_SCENARIO_FIN_STRS = "GET_SCENARIO_FIN_STRS";
export const SET_FIN_ERRORS_NULL = "SET_FIN_ERRORS_NULL";
export const SET_SCENARIO_FIN_STR = "SET_SCENARIO_FIN_STR";
export const SET_ERROR_OBJ = "SET_ERROR_OBJ";
export const SET_DEALROOM_FIN_ERRORS = "SET_DEALROOM_FIN_ERRORS";
export const SET_DEALROOM_FIN_ERRORS_OBJ_CREATING = "SET_DEALROOM_FIN_ERRORS_OBJ_CREATING";
export const DELETE_PPROJECT_FROM_DEALROOM = "DELETE_PPROJECT_FROM_DEALROOM";
export const DELETE_FIN_STR_FROM_DEALROOM = "DELETE_FIN_STR_FROM_DEALROOM";
export const GET_DEALROOM_PROJECTS_SCENARIOS = "GET_DEALROOM_PROJECTS_SCENARIOS";
export const GET_SCENARIO_PROJECTS = "GET_SCENARIO_PROJECTS";
export const ACTIVATE_ACCOUNT = "activate_account";
export const FORGOT_PASSWORD_USER = "forgot_passowrd_user";
export const RESET_PASSWORD_USER = "reset_passowrd_user";
export const GET_CONTRACT_SCHEMAS = "get_contract_schemas";
export const NEW_PROJECT_OPENING = "NEW_PROJECT_OPENING";
export const EMPTY_SCHEMA_TEMPLATE = "EMPTY_SCHEMA_TEMPLATE";
export const ADD_PROJECTS_BY_SCHEMAS = "ADD_PROJECTS_BY_SCHEMAS";
export const SET_NEW_PROJECT_INFO = "set_new_project_info";
export const GET_SCHEMA_TEMPLATE = "GET_SCHEMA_TEMPLATE";
export const GET_EPC_SCHEMAS = "get_epc_schemas";
export const SET_SCHEMAS_TEMPLATES = "set_schemas_templates";
export const ADD_SCHEMA = "add_schema";
export const DELETE_SCHEMA = "delete_schema";
export const EMPTY_FIN_STRUCTURE = "EMPTY_FIN_STRUCTURE";
export const SAVE_NAME = "save_name";
export const SCHEMAS_ERROR = "schemas_error";
export const SET_ERROR = "set_error";
export const NEM_FIN_STR_CREATING_STATUS = "NEM_FIN_STR_CREATING_STATUS";
export const SET_FIN_ERROR = 'SET_FIN_ERROR';
export const EMPTY_FIN_ERROR = 'EMPTY_FIN_ERROR';
export const EDIT_SCHEMA = "edit_schema";
export const GET_FINANCICAL_SCHEMAS = "get_financical_schemas";
export const REMOVE_PROJECT = "remove_project";
export const GET_FINANCICAL_SCHEMAS_TEMPLATES =
  "get_financical_schemas_templates";
export const SET_FINANCICAL_SCHEMAS_TEMPLATES =
  "set_financical_schemas_templates";
export const GET_PROJECTS_BY_SCHEMAS =
  "get_projects_by_schemas";
export const ADD_WATERFALL_SCHEMAS = "add_waterfall_schemas";
export const EDIT_WATERFALL_SCHEMAS = "edit_waterfall_schemas";
export const DELETE_WATERFALL_SCHEMAS = "delete_waterfall_schemas";
export const GET_FINANCICAL_SCHEMA_BY_ID = "get_financical_schema_by_id";
export const GET_SEASONALITY_SCHEMAS = "get_seasonality_schemas";
export const DELETE_SEASONALITY_SCHEMAS = "delete_seasonality_schemas";
export const UPDATE_SEASONALITY_SCHEMAS = "update_seasonality_schemas";
export const CREATE_SEASONALITY_SCHEMAS = "create_seasonality_schemas";
export const token = '5c8af2ef99d887c72160fea8f309b9637f2cde77';




// WEBPACK FOOTER //
// ./src/store/actions/types.js